module.exports = __webpack_public_path__ + "img/ticket_status05.d28c1741.png";